import React, { FunctionComponent } from "react";

import { AnyOrderItem } from "../../../../../stores/slices/cartSlice";
import { AdditionalItem } from "./AdditionalItem";
import { MandatoryItem } from "./MandatoryItem";

export const LineItems: FunctionComponent<{
  orderItem: AnyOrderItem;
}> = ({ orderItem }) => {
  const optionalItems = [
    ...orderItem.includedOptionalLineItemList,
    ...orderItem.additionalOptionalLineItemList,
  ];

  if (!(orderItem.mandatoryLineItemList.length + optionalItems.length)) {
    return null;
  }
  return (
    <div className="divide-y border-t border-b col-span-9 mt-2">
      {orderItem.mandatoryLineItemList.map((item) => (
        <MandatoryItem item={item} key={item.lineItemId} />
      ))}
      {optionalItems.map((item) => (
        <AdditionalItem
          key={item.lineItemId}
          lineItem={item}
          orderItem={orderItem}
        />
      ))}
    </div>
  );
};
